exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/categories/category-pop-up/category-pop-up.component.css
// module id = ../../../../../src/app/admin/categories/category-pop-up/category-pop-up.component.css
// module chunks = 39